import { css } from "@compiled/react";

import { Icon } from "@/libraries/wpl/foundations/src";

import {
    FilterCategories,
    FilterOptions,
    LocalizedFilterOptions,
    SubFilterObject,
    isContentPlatformFacetAvailable
} from "../utils";

type FilterModalBasicProps = {
    subFilter: FilterCategories;
    subFilterObject: SubFilterObject;
    updateFilterObject: (subFilterName: string) => void;
};

export const CustomerStoryFilterModalBasic = ({
    subFilter,
    subFilterObject,
    updateFilterObject
}: FilterModalBasicProps) => {
    const localizedMap = LocalizedFilterOptions();

    return (
        <div
            css={customerStoryFilterModalBasicStyle}
            className={subFilter}
            id="customer-story-modal-component-parent"
        >
            <div>
                {Object.keys(subFilterObject).map(
                    (filterOptionName: string, index: number) => {
                        const filterObject = subFilterObject[
                            filterOptionName
                        ] as FilterOptions;
                        const active: boolean = filterObject.stagedActive;
                        const optionId = `option-${subFilter.replace(
                            /\s/g,
                            ""
                        )}-${index}`;
                        return (
                            <label
                                key={filterOptionName}
                                htmlFor={optionId}
                                className="filter-radio-button-container"
                            >
                                <input
                                    id={optionId}
                                    type="checkbox"
                                    onClick={() =>
                                        updateFilterObject(filterOptionName)
                                    }
                                    css={actualInputStyle}
                                />
                                <span className={active ? "checked" : ""}>
                                    <Icon
                                        name="featurecheckmark"
                                        size="xs"
                                        color="#FFFFFF"
                                    />
                                </span>
                                {isContentPlatformFacetAvailable(subFilter)
                                    ? filterOptionName
                                    : localizedMap[filterOptionName]}
                            </label>
                        );
                    }
                )}
            </div>
        </div>
    );
};

const customerStoryFilterModalBasicStyle = css({
    "position": "absolute",
    "backgroundColor": "white",
    "borderRadius": "20px",
    "zIndex": 2,
    "insetBlockStart": "55px",
    "padding": "16px 24px 24px 24px",
    "flexDirection": "column",
    "boxShadow": "0px 8px 12px 0px #091E4226, 0px 0px 1px 0px #091E424F",
    "& > div": {
        display: "flex",
        flexDirection: "column"
    },
    ".filter-radio-button-container": {
        "margin": "8px 0 0 0",
        "cursor": "pointer",
        "display": "flex",
        "flexWrap": "nowrap",
        "alignItems": "center",
        "justifyContent": "flex-start",
        ":hover": {
            span: {
                border: "2px solid #1868DB"
            }
        },
        "span": {
            width: "20px",
            height: "20px",
            borderRadius: "3px",
            border: "2px solid #DDDEE1",
            flexBasis: "20px",
            marginInlineEnd: "8px",
            background: "#FFFFFF",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            svg: {
                opacity: 0
            }
        },
        "span.checked": {
            background: "#1868DB",
            border: "2px solid #1868DB",
            svg: {
                opacity: 1
            }
        }
    }
});

const actualInputStyle = css({
    position: "absolute",
    zIndex: -1,
    opacity: 0
});
